import { useApiClient } from 'bff/ApiClientProvider';
import { ReportingGetTopFundsRequest } from 'bff/client';
import { queryOptions } from '@tanstack/react-query';

export const getTopFunds = (request: ReportingGetTopFundsRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['top-funds'],
    queryFn: () => reportingApi.reportingGetTopFunds(request),
    select: (response) => response.data?.topFunds
  });
};
